<template>
  <!-- 角色权限 -->
  <div>
    <div class="f-search-block">
      <div class="search-items">
        <div class="field-item">
          <div class="field-item-label">
            角色名称：
          </div>
          <div class="field-item-control">
            <el-input
              v-model="params.search"
              placeholder="请输入角色名称"
              class="input-m m-r-6"
              clearable
            />
          </div>
        </div>
      </div>
      <div class="search-btns">
        <el-button
          type="primary"
          @click="haddleSearch"
        >
          查询
        </el-button>
      </div>
    </div>
    <div class="f-toolbar-block">
      <el-button
        type="primary"
        @click="haddleEdit()"
      >
        新建角色
      </el-button>
      <el-button
        type="primary"
        @click="haddleDelete"
      >
        批量删除
      </el-button>
    </div>
    <div class="f-table-block">
      <!-- 表格 -->
      <el-table
        ref="multipleTable"
        v-loading="loading"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
        />

        <el-table-column
          prop="role_name"
          label="角色名称"
          show-overflow-tooltip
        />
        <el-table-column
          prop="auth_name"
          label="角色权限"
          show-overflow-tooltip
        />
        <el-table-column
          prop="status"
          label="状态"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1">已启用</span>
            <span v-if="scope.row.status === 2">已禁用</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="bind_num"
          label="绑定员工数"
          show-overflow-tooltip
        />

        <el-table-column
          label="操作"
          width="150"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="haddleEdit(scope.row)"
            >
              编辑
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="disableItem(scope.row)"
            >
              {{ scope.row.status === 1 ? '禁用' : '启用' }}
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="deleteItem(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页器 -->
      <el-pagination
        class="table-pagination"
        background
        :current-page="params.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="params.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total_count"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 新建角色模态框 -->
    <el-dialog
      title="新建角色"
      :visible.sync="createVisible"
      width="660px"
      :before-close="handleEditClose"
    >
      <div>
        <el-row
          type="flex"
          align="middle"
          class="create-row"
        >
          <el-col :span="3">
            角色名称
          </el-col>
          <el-col :span="21">
            <el-input
              v-model="createParams.role_name"
              placeholder="请输入内容"
              class="input-m"
            />
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            角色权限
          </el-col>
          <el-col :span="21">
            <el-checkbox-group v-model="createParams.checkList">
              <el-checkbox
                v-for="item in authList"
                :key="item.auth_id"
                :label="item.auth_id"
              >
                {{ item.auth_name }}
              </el-checkbox>
            </el-checkbox-group>
          </el-col>
        </el-row>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="createVisible = false">取 消</el-button>
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="submitCreate"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getRoleList,
  getAuthList,
  createRole,
  changeRoleStatus,
  deleteRole
} from '@/api/staffManagement/rolePrivileges'
export default {
  data () {
    return {
      loading: false, //列表的加载
      params: {
        search: '',
        page: 1,
        page_size: 20
      },
      tableData: [],
      total_count: 0,
      createVisible: false,
      createParams: {},
      authList: [], //角色权限列表
      editItem: {}, //编辑中的角色信息
      submitLoading: false, //编辑的加载
      deleteLoading: false, //删除的加载
      deleteRoleIds: '', //删除参数，角色id
      multipleSelection: [] //列表多选数组
    }
  },
  mounted () {
    this.getList()
    this.getAuthList()
  },
  methods: {
    // 获取列表数据
    async getList () {
      this.loading = true
      const data = await getRoleList(this.params)
      if (data) {
        this.tableData = data.list
        this.total_count = data.total_count
        this.loading = false
      }
    },
    // 查询列表数据
    haddleSearch () {
      this.params.page = 1
      this.getList()
    },
    // 获取权限列表
    async getAuthList () {
      const data = await getAuthList()
      if (data) {
        this.authList = data.list
      }
    },
    // 新建/编辑 角色模态框
    haddleEdit (item) {
      if (item) {
        this.editItem = item
        this.createParams = {
          role_name: item.role_name,
          role_id: item.role_id,
          checkList: item.bind_auth_id
        }
      } else {
        this.editItem = {}
        this.createParams = {
          role_name: '',
          auth_id: '',
          role_id: '',
          checkList: []
        }
      }
      this.createVisible = true
    },
    // 关闭编辑角色模态框
    handleEditClose () {
      this.createVisible = false
    },
    // 新建角色
    async submitCreate () {
      let { role_name, checkList } = this.createParams
      let params = {
        role_name,
        auth_id: checkList.join(','),
        role_id: this.editItem.role_id || ''
      }
      if (!params.role_name) {
        return this.$message.error('角色名称不能为空')
      } else if (!params.auth_id) {
        return this.$message.error('请选择权限')
      } else {
        this.submitLoading = true
      }
      const data = await createRole(params).catch(() => {
        this.submitLoading = false
      })
      if (data) {
        this.submitLoading = false
        this.createVisible = false
        this.$message({
          type: 'success',
          message: '保存成功'
        })
        this.haddleSearch()
      }
    },
    // 启用/禁用列表
    async disableItem (item) {
      let params = {
        status: item.status === 1 ? 2 : 1,
        role_id: item.role_id
      }
      const data = await changeRoleStatus(params)
      if (data) {
        this.$message({
          type: 'success',
          message: '修改成功'
        })
        this.haddleSearch()
      }
    },

    // 删除列表
    deleteItem (item) {
      this.deleteRoleIds = item.role_id.toString()
      this.submitDelete()
    },
    // 多选
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 批量删除
    haddleDelete () {
      if (this.multipleSelection.length <= 0) {
        return this.$message.error('请至少勾选一个需要删除的角色')
      }
      let deleteRoleIds = []
      this.multipleSelection.forEach((v) => {
        deleteRoleIds = deleteRoleIds.concat(v.role_id)
      })
      this.deleteRoleIds = deleteRoleIds.join(',')
      this.submitDelete()
    },
    // 删除操作
    submitDelete () {
      this.$confirm('请确认是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const data = await deleteRole({ role_id: this.deleteRoleIds })
          if (data) {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.deleteRoleIds = ''
            this.haddleSearch()
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 列表分页
    handleSizeChange (val) {
      this.params.page = 1
      this.params.page_size = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.search-btn {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  li {
    margin-right: 20px;
  }
}
.create-row {
  margin-bottom: 20px;
}
</style>
